import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Form, Button, Table, Collapse } from 'react-bootstrap-v5';

async function postImage({image}) {
  const formData = new FormData();
  formData.append("image", image)
  const result = await axios.post(`${process.env.REACT_APP_API_URL}/images/test`, formData, { headers: {'Content-Type': 'multipart/form-data'}})
  return result.data
}

export default function Subscription() {
  const { id } = useParams();

  

  const [subscriptionData, setSubscriptionData] = useState({
    subsciption_type: '',
    start_date: '',
    end_date: '',
    amount: '',
    payment_log: ''
  });

  const [subscriptions, setSubscriptions] = useState([]);
  const [status, setStatus] = useState('');
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(true);


  const [file, setFile] = useState(null)
  const [filePreview, setFilePreview] = useState(null)

  const fileSelected = event => {
    const selectedFile = event.target.files[0]
    if (selectedFile) {
      setFile(selectedFile)
      // Create a preview URL for the image
      const previewUrl = URL.createObjectURL(selectedFile)
      setFilePreview(previewUrl)
    }
  }

  const loadAllSubscriptions = useCallback(async (headers) => {
    const url = `${process.env.REACT_APP_API_URL}/getallsubscriptions/${id}`;
    try {
      const res = await axios.get(url, { headers });
      setSubscriptions(res.data);
    } catch (err) {
      console.log("Error loading subscriptions:", err);
    }
  }, [id]);

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatSubscriptionType = (type) => {
    switch (type) {
      case "99":
        return "Black-Label";
      case "98":
        return "Super-Luxe";
      case "97":
        return "Premium";
      default:
        return type;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    loadAllSubscriptions(headers);
  }, [id, loadAllSubscriptions, editId]);

  useEffect(() => {
    if (subscriptions.length === 0) {
      setIsFormOpen(true);
    } else {
      setIsFormOpen(false);
    }
  }, [subscriptions.length]);

  const validateFields = () => {
    const requiredFields = {
      'Type': subscriptionData.subsciption_type,
      'Start Date': subscriptionData.start_date,
      'End Date': subscriptionData.end_date,
      'Amount': subscriptionData.amount,
      'Payment Log': subscriptionData.payment_log
    };

    const emptyFields = Object.entries(requiredFields)
      .filter(([_, value]) => !value)
      .map(([fieldName, _]) => fieldName);

    if (emptyFields.length > 0) {
      setError(`Please fill in all required fields: ${emptyFields.join(', ')}`);
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const url = `${process.env.REACT_APP_API_URL}/savesubscription/${id}`;
    setStatus("saving...");
    setError("");

    try {
      let filePath = '';
      // If there's a file selected, upload it first
      let paymentLog = subscriptionData.payment_log;
      if (file) {
        const formData = new FormData();
        formData.append("image", file);
        
        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/images/test`, 
          formData, 
          { headers: { ...headers, 'Content-Type': 'multipart/form-data' } }
        );
        
        // Update payment log with the uploaded file information
        filePath = `${subscriptionData.payment_log}\n\nUploaded file: ${uploadResponse.data.imagePath}`;
      }

      // Save subscription with updated payment log
      await axios.post(url, { ...subscriptionData, filePath: filePath }, { headers });
      setStatus("saved");
      setError("");
      await loadAllSubscriptions(headers);
      
      // Reset form and file states
      setSubscriptionData({
        subsciption_type: '',
        start_date: '',
        end_date: '',
        amount: '',
        payment_log: ''
      });
      setFile(null);
      setFilePreview(null);
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.error || "error saving data");
      setStatus("");
    }
  };

  const handleUpdate = async () => {
    if (!validateFields()) return;

    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const editUrl = `${process.env.REACT_APP_API_URL}/editsubscription/${id}/${editId}`;
    try {
      await axios.put(editUrl, subscriptionData, { headers });
      
      setSubscriptionData({
        subsciption_type: '',
        start_date: '',
        end_date: '',
        amount: '',
        payment_log: ''
      });
      
      setEditId(null);
      await loadAllSubscriptions(headers);
    } catch (err) {
      console.log("Error editing subscriptions:", err);
      setError("Error editing subscriptions");
    }
  };

  const handleDelete = async (subscriptionId) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const url = `${process.env.REACT_APP_API_URL}/deletesubscription/${id}/${subscriptionId}`;

    try {
      await axios.delete(url, { headers });
      loadAllSubscriptions(headers);
    } catch (err) {
      console.log("Error deleting subscriptions:", err);
    }
  };

  return (
    <div className="container">
      <div className="App">
        {filePreview && (
          <div className="mt-3">
            <h4>Selected File Preview:</h4>
            <img 
              src={filePreview} 
              alt="Preview" 
              style={{ maxWidth: '200px', maxHeight: '200px' }}
            />
            <p>File name: {file.name}</p>
            <p>File size: {(file.size / 1024).toFixed(2)} KB</p>
          </div>
        )}
      </div>

      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-end mb-3">
            <Button 
              onClick={() => setIsFormOpen(!isFormOpen)}
              variant="outline-primary"
              size="sm"
            >
              {isFormOpen ? 'Hide Form' : 'Add Subscription'}
            </Button>
          </div>

          <Collapse in={isFormOpen}>
            <div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      value={subscriptionData.subsciption_type}
                      onChange={(e) =>
                        setSubscriptionData({ ...subscriptionData, subsciption_type: e.target.value })
                      }
                      required
                    >
                      <option value="">Please Select</option>
                      <option value="99">Black-Label</option>
                      <option value="98">Super-Luxe</option>
                      <option value="97">Premium</option>
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={subscriptionData.start_date}
                      onChange={(e) =>
                        setSubscriptionData({ ...subscriptionData, start_date: e.target.value })
                      }
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={subscriptionData.end_date}
                      onChange={(e) =>
                        setSubscriptionData({ ...subscriptionData, end_date: e.target.value })
                      }
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      type="number"
                      value={subscriptionData.amount}
                      onChange={(e) =>
                        setSubscriptionData({ ...subscriptionData, amount: e.target.value })
                      }
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-md-12">
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Log</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={subscriptionData.payment_log}
                      onChange={(e) =>
                        setSubscriptionData({ ...subscriptionData, payment_log: e.target.value })
                      }
                      required
                    />
                  </Form.Group>
                  <div className="mb-3">
                    <Form.Label>Upload Payment Receipt</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={fileSelected}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  {editId ? 
                    <Button onClick={handleUpdate} style={{ marginTop: "20px" }}>Update</Button> : 
                    <Button onClick={handleSave} style={{ marginTop: "20px" }}>Save</Button>
                  }
                  <div className="status">{status}</div>
                  <div className="error" style={{ color: 'red' }}>{error}</div>
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h2>All Subscriptions</h2>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Amount</th>
                <th>Payment Log</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.map((subscription) => (
                <tr key={subscription.id}>
                  <td>{formatSubscriptionType(subscription.subsciption_type)}</td>
                  <td>{formatDateForDisplay(subscription.start_date)}</td>
                  <td>{formatDateForDisplay(subscription.end_date)}</td>
                  <td>{subscription.amount}</td>
                  <td>{subscription.payment_log}</td>
                  <td>
                    <Button className="btn btn-outline-primary btn-sm me-2" onClick={() => {
                      setEditId(subscription.id);
                      setIsFormOpen(true);
                      setSubscriptionData({
                        subsciption_type: subscription.subsciption_type || '',
                        start_date: formatDateForInput(subscription.start_date) || '',
                        end_date: formatDateForInput(subscription.end_date) || '',
                        amount: subscription.amount || '',
                        payment_log: subscription.payment_log || ''
                      });
                    }}>
                      Edit
                    </Button>
                    <Button variant="danger" size="sm" onClick={() => handleDelete(subscription.id)}>
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
} 